var _path;
function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgQuoteIcon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 62,
    height: 37,
    viewBox: "0 0 62 37",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M.831 36.829h21.657L31.336.569h-15.84L.83 36.83zm30.629 0h21.532l8.91-36.26h-15.84L31.46 36.83z",
    fill: "#fff"
  })));
}
export default SvgQuoteIcon;